// hooks/useSessionManager.ts
import { useEffect } from 'react';
import { store } from '../stores/store';

export function useSessionManager() {
	useEffect(() => {
		if (!store.sessionStore.isTimerEnabled) return;

		// Handler to update the lastActive timestamp on user activity
		const handleUserActivity = () => {
			store.sessionStore.touch();
		};

		// Listen to common user interaction events
		window.addEventListener('click', handleUserActivity);
		window.addEventListener('keydown', handleUserActivity);
		window.addEventListener('touchstart', handleUserActivity);

		// Cleanup event listeners on unmount
		return () => {
			window.removeEventListener('click', handleUserActivity);
			window.removeEventListener('keydown', handleUserActivity);
			window.removeEventListener('touchstart', handleUserActivity);
		};
	}, []);
}
